<div class="container">
    <div class="row justify-content-center">
        <div class="col-4">
            <app-upload-file>
                <div class="logo text-center">
                    <span>LOGO</span>
                    <br>
                    <span>เลือก</span>
                </div>
            </app-upload-file>
            <br>
            <input type="text" class="form-control" placeholder="ชื่อร้าน">
        </div>
    </div>
</div>